import { render, staticRenderFns } from "./PmRewardNew.vue?vue&type=template&id=38c89178"
import script from "./PmRewardNew.vue?vue&type=script&lang=js"
export * from "./PmRewardNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports